//import React from 'react';
// 3) HELMET - Add this import to each page
import React, { Fragment, useRef, useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { gsap } from 'gsap';
import { useGSAP } from "@gsap/react";
import { DrawSVGPlugin } from '../js/DrawSVGPlugin.js'; // Import the JavaScript file
import { MotionPathPlugin} from '../js/MotionPathPlugin.js'; // Import the JavaScript file
import { SteppedEase } from "gsap";
// IMAGES
import heroimg_contact from '../images/heros/contact.webp'; 
import hero_steam from '../images/contact/steam-fx-sprite.png'; 
import icon_email from '../images/icons/icon-email.svg';
import icon_phone from '../images/icons/icon-phone.svg'; 

// Component for From processing
import { ContactForm_JS } from '../components/ContactForm_JS';


gsap.registerPlugin(DrawSVGPlugin);
gsap.registerPlugin(MotionPathPlugin);













const Contact = () => {

const bgfx_ref_2 = useRef();





  useGSAP(() => {

   // PRESETS HERO
   gsap.set(".contact-transition-curtain", {left:"-4000", top:"-4000"});

     // =================================== //
      // HERO ANIMATION
     // =================================== //
     let tl_hero_contact = gsap.timeline({});
     // 1. Define dash and gap sizes
    const dashLength = 4;
    const gapLength = 24;
    const totalPatternLength = dashLength + gapLength; // 40

    gsap.set(".tracks", {
      strokeDasharray: `${dashLength}, ${gapLength}`
    });
    tl_hero_contact .to(".tracks", {
      strokeDashoffset: totalPatternLength,
      duration: 0.25, // Adjust for speed
      ease: "none",
      repeat: -1
    })
     .to("#status-gauge", {
      rotate:360,
      duration: 3, // Adjust for speed
      ease: "none",
       transformOrigin: "50% 50%",
      repeat: -1
    });













// <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
 // DYNAMIC DELAY VALUE
 // this changes our delay based on inital applcation loadinbg vs page tp page transtions
const dynamicDelay = window.isInitialPreload ? 6 : 2;








 const tl_contact_content = gsap.timeline({

  //  <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
// Dynamic Dealy Value - add onComplete code to all starter timelines.
  onComplete: () => {window.isInitialPreload = false;}

});







/* presets */
gsap.set('.contact-sect-1 h2', { opacity:0, x:50 });
gsap.set('.contact-sect-2 h2', { opacity:0, x:-50 });
gsap.set('.contact-info, .contact-form-wrapper', { opacity:0, y:50 });


tl_contact_content
.to(".contact-sect-1 h2", {opacity:1, x:0, duration: 0.75, overwrite: 'auto', }, `+=${dynamicDelay}`)  //<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
.to(".contact-sect-2 h2", {opacity:1, x:0, duration: 0.75, delay:"-=0.5"})
.to(".contact-info", {opacity:1, y:0, duration: 0.5, delay:"-=0.75"})
.to(".contact-form-wrapper", {opacity:1, y:0, duration: 0.5, delay:"-=0.75"});






  }, { scope: bgfx_ref_2  });  //<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
// End of useGSAP




return(

  

<main className="page-content page-id_contact" data-page-id="contact" ref={bgfx_ref_2}>
<HelmetProvider> 
<Fragment> 
    <Helmet>
     
        <title>Contact | Get A Quote | Mark Hawkins</title>
        <meta name="description" content="Reach out to me if you have questions or if your interested in getting a project quote."/>
    </Helmet>
  </Fragment>
  </HelmetProvider>  

  <svg version="1.1" className="contact-transition-curtain" x="0px" y="0px" viewBox="0 0 191 191" xmlSpace="preserve">
     <path className="st0" d="M95.5,190.5c-52.4,0-95-42.6-95-95s42.6-95,95-95s95,42.6,95,95S147.9,190.5,95.5,190.5z"/>
     <path className="st1" d="M95.5,1C147.6,1,190,43.4,190,95.5S147.6,190,95.5,190S1,147.6,1,95.5S43.4,1,95.5,1 M95.5,0
	C42.8,0,0,42.8,0,95.5S42.8,191,95.5,191S191,148.2,191,95.5S148.2,0,95.5,0L95.5,0z"/>
 </svg>

  <div className="hero-container-wrap"> 
  <div className='hero-container'>
  <div className="hero-mask">

  <div className='mask-svg'>
    <svg viewBox="0 0 0 0" height="0" width="0">
      <defs> 
          <clipPath id="clipping" clipPathUnits="objectBoundingBox" transform="scale(0.00099, 0.00105)"> 
              <path id="dotmask" d="M853,0c0,357.9-290.1,648-648,648c-71.6,0-140.6-11.6-205-33.1v158.6C65.4,790.8,134.1,800,205,800
			c441.8,0,800-358.2,800-800H853z"/>
              <path id="hoopmask"  d="M0,0v501.1c63.2,25.9,132.4,40.2,205,40.2c298.9,0,541.3-242.3,541.3-541.3H0z"/>
	        </clipPath>
      </defs> 
    </svg>
  </div>
 


<div className="heroimage">
  



 <div className="hero-steam"></div>


<svg version="1.1"  viewBox="0 0 2400 1750" className="hero-tracks-fx">
  <g id="tracks">
    <path id="track-path-right" className="tracks" d="M716,875s-1.9-17.7-33.4-22.7-59.7,21.8-102.6,66.5c-23.9,24.9-43,49.3-95.8,115.2-61.9,77.2-115.2,158-115.2,158l-253,330"/>
    <path id="track-path-left" className="tracks" d="M799,875s16.3-21.4,27.4-23.2c29.6-4.9,66.2,39.5,83,59.2s101.4,144.6,117.5,170.2c16.1,25.6,278.1,416.3,278.1,416.3"/>
  </g>
  <g id="status-gauge">
    <g id="gauge">
      <path  d="M1573.7,165.4c0,3-1.7,5.6-4.1,7.1l9.7,16.3c1.5-.8,2.9-1.8,4.1-2.9,1.5-1.3,2.8-2.7,4.1-4.3,3.4-4.5,5.5-10.1,5.5-16.1h-19.3Z"/>
      <rect id="wheel-spacer" x="1565.4" y="192.4" width="0" height="0"/>
      <path  d="M1565.3,157.2c1.5,0,2.8.4,4,1l9.4-16.4c-4-2.2-8.6-3.4-13.4-3.4s-10,1.4-14.1,3.8l9.8,16.2c1.3-.7,2.7-1.2,4.3-1.2Z"/>
      <path  d="M1557,165.4h-19.2c0,6,2,11.6,5.5,16.1,1.3,1.6,2.6,3,4.1,4.3,1.3,1.1,2.7,2.1,4.1,2.9l9.7-16.3c-2.5-1.4-4.1-4.1-4.1-7.1Z"/>
    </g>
  </g>
</svg>



  <img src={heroimg_contact} alt="portfolio background hero - picture of subway tunnel" />
</div>



</div>

  <div className='hero-text'>


    <div className="page-h1">
        <h1 style={{ opacity: 0, visibility: 'hidden' }}>Contact</h1>
        <div className="h1-accent"><span></span></div>
    </div>
        <strong>Reach out to me. Get a Quote.</strong>


  </div>
</div>
</div>


<div className="content">

  <div className="flex-columns">
   <div className="col-50 contact-sect-1"> 
	  <h2>Get in touch</h2>
			<div className="contact-info">
				<p>Ready to create an awesome marketing design, commerce website or branding for your business? Get a quote by sending me a text message or email. Available Mon-Fri 9am - 6pm EST.</p>
                                                                                                                      
  

       <div className="contact-info-panel">

				   <div className="contact-email">info@markhawkinsdesigns.com</div>
           <a className="contact-phone" href="tel:3059030641">305-903-0641</a> </div>
     </div>
	</div>		
	
		  
	 
  <div className="col-50 contact-sect-2">	
		 <h2>Send a message</h2>
<div className="contact-form-wrapper">
 <ContactForm_JS />
</div>


</div>

</div>

</div>
</main>


);
};
export default Contact;
